export const ENTITY_NAME = '题目标签';
export const API_BASE_URL = '/quiz-questions/tags';
